import { ReactNode, MutableRefObject } from "react";
import useNetworkCreateForm from "../hooks/useNetworkCreateForm";
import { NetworkFormContext } from "./NetworkFormContext";
import { PredefinedParams } from "../../../../../components/slidingpanel/type";

type Props = {
  children: ReactNode;
  nameRef: MutableRefObject<HTMLElement | null>;
  regionRef: MutableRefObject<HTMLElement | null>;
  subnetRefs: React.RefObject<HTMLDivElement>[];
  setSubnetRefs: React.Dispatch<
    React.SetStateAction<React.RefObject<HTMLDivElement>[]>
  >;

  predefined_params?: PredefinedParams;
};

const NetworkFormProvider = ({
  children,
  nameRef,
  regionRef,
  subnetRefs,
  setSubnetRefs,
  predefined_params,
}: Props) => {
  const form = useNetworkCreateForm({
    nameRef,
    regionRef,
    subnetRefs,
    setSubnetRefs,
    predefined_params,
  });

  return (
    <NetworkFormContext.Provider value={form}>
      {children}
    </NetworkFormContext.Provider>
  );
};

export default NetworkFormProvider;
